import { useState, useEffect } from 'react';

export default function useWindowWidth() {
  const init = typeof window === 'undefined' ? 0 : window.innerWidth;
  const [width, setWidth] = useState(init);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return width;
}
